export default function order(state = {}, action) {
    switch (action.type) {

        case "send_trade_chat_message_success":
            return { ...state, status: "send_trade_chat_message_success", reply: action.reply, t: Date.now() };
        case "send_trade_chat_message_fail":
            return { ...state, status: "send_trade_chat_message_fail", state: action.status, t: Date.now() };
        
        case "empty":
            return { ...state, status: '', t: Date.now() };
        default:
            return state;
    }
}